import request from '@/utils/request';
import { ResCode, PagingReq } from './baseDefine';
export interface ReqOrders extends PagingReq {
    searchCompanyID: number;
    userNO: string;             // 用户编号
    state: number;              // 支付状态
    startTime: string;          // 开始时间
    endTime: string;            // 结束时间
}
export interface OrderList {
    code: ResCode;
    msg: string;
    data: OrderlistData;
}
/**
 * 
 *
 * @export
 * @interface OrderlistData
 */
export interface OrderlistData {
    orders: MetersData;
}
export interface MetersData {
    list: Order[];
    curPage: number;
    totalPage: number;
    totalCount: number;
    nextPage: number;
}
export interface Order {
    id: number;              // 数据库ID
    payTime: string;         // 支付时间
    money: number;           // 支付金额
    userEntityID: number;    // 用户ID
    MeterTypeName: string;   // 设备类型名称
    MeterID: string;         // 设备ID
    createTime: string;      // 订单生成时间
    email: string;           // 用户email
    userID: string;          // userID
    payState: number;
}
export function orders(req: ReqOrders): Promise<OrderList> {
    return request.post<OrderList>('/api/bill/orders', req);
}